class Sorter {
  sortObjectsByProperty(objects, property) {
    const newObjects = Array.from(objects);
    newObjects.sort((a, b) => {
      if (a[property] < b[property]) {
        return -1;
      }
      if (a[property] > b[property]) {
        return 1;
      }
      return 0;
    });
    return newObjects;
  }
}
const sorter = new Sorter();
export { sorter };